import { safeCssUrl } from "../../lib/url";
import { useController, useGame } from "../context";

export function CollectionsScreen() {
  const controller = useController();
  const collections = useGame((s) => s.collections);
  const busy = useGame((s) => s.busy);
  return (
    <section className="screen">
      <h3 className="section-title">Подборки фильмов</h3>
      {collections === null ? (
        <p className="muted">Загружаем подборки…</p>
      ) : collections.length === 0 ? (
        <p className="muted">Подборок пока нет</p>
      ) : (
        <div className="collections">
          {collections.map((collection) => (
            <button
              type="button"
              key={collection.id}
              className="collection-card"
              disabled={busy}
              style={{ backgroundImage: safeCssUrl(collection.cover_url) }}
              onClick={() => void controller.pickCollection(collection.id)}
            >
              <div className="collection-overlay">
                <b>{collection.title}</b>
                <br />
                <span>{collection.desc}</span>
              </div>
            </button>
          ))}
        </div>
      )}
      <button type="button" className="btn" onClick={() => controller.goHome()}>
        Назад
      </button>
    </section>
  );
}
